/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Input_Convert_PdfInputs */



/**
* | output |
* | --- |
* | "Convert PDF to jpg" |
*
* @param {Plan_Input_Convert_PdfInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const plan_input_convert_pdf = /** @type {((inputs?: Plan_Input_Convert_PdfInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Input_Convert_PdfInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Convert PDF to jpg")
	return /** @type {LocalizedString} */ ("Convertir PDF en jpg")
});